"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const WinstonContext_1 = require("./WinstonContext");
const WinstonProvider = ({ children, logger }) => {
    const WinstonContext = WinstonContext_1.getWinstonContext();
    return (react_1.default.createElement(WinstonContext.Consumer, null, (context = {}) => {
        if (logger && context.logger !== logger) {
            context = Object.assign({}, context, { logger });
        }
        if (!context.logger) {
            throw new Error('WinstonProvider was not passed a logger instance. Make ' +
                'sure you pass in your logger via the "logger" prop.');
        }
        return (react_1.default.createElement(WinstonContext.Provider, { value: context }, children));
    }));
};
exports.default = WinstonProvider;
//# sourceMappingURL=WinstonProvider.js.map